const bailoutCodes = {
    PART_NOT_FOUND: 18,
    ROOF_GLASS_PART_NOT_FOUND: 23,
    STORAGEIND: 85,
};

export { bailoutCodes };
